const resultScrollTo = require('vue-scrollto')

export default {
  toApresentation () {
    resultScrollTo.scrollTo('#intro-professional')
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/loading-page/gadget/resources/methods.js